import DashboardHome from './components/DashboardHome'
import Dispatch from './components/Dispatch'

function App() {
  return (
    <>
      {/* <DashboardHome /> */}
      <Dispatch />
    </>
  );
}

export default App;
